import React from 'react';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { colors } from '../styles';

const ModalContainer = styled('div')(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 500px;
  background-color: #FDFDFD;
  border-radius: 5px;
  padding: 16px 32px;
`);

const H2 = styled('h2')(`
  font-size: 24px;
  line-height:24px;
  text-align: center;
`);

const F3 = styled('h2')(`
  font-size: 16px;
  line-height:24px;
  font-weight: 500;
  text-align: center;
`);

const PrimaryButton = styled('button')(`
  padding: 10px 24px;
  display: flex;
  margin: 8px auto;
  justify-content: center;
  color: #FCFDFD;
  height: 36px;
  background: ${colors.black};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
  border-radius: 4px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  border: 0;
  cursor: pointer;
  &:hover {
    opacity: 0.7
  }
`);

interface Props {
  modalStatus: boolean;
  closeModal: any;
  custom?: any;
}

const ComingSoonModal = ({ modalStatus, closeModal, custom }: Props) => {
  const defaultText = 'This page is currently being built, please check back soon for updates.';

  return (
    <Modal
      open={modalStatus}
      onClose={closeModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ModalContainer>
        <div>
          <H2>Coming Soon!</H2>
          <F3>{custom ? custom : defaultText}</F3>
        </div>
        <PrimaryButton onClick={closeModal}>Close</PrimaryButton>
      </ModalContainer>
    </Modal>
  );
};

export default ComingSoonModal;
